import api from './api';

const findMedicoByName = async payload => {
  const response = await api.get('/medicos/nome', {
    params: { nome: payload?.nome.trim() },
  });

  return response.data;
};

const updateMedico = async payload => {
  const response = await api.put('/medico', payload);
  return response.data.message;
};

const getAgendaAberta = async ({ id, dt, procedimentos }) => {
  const response = await api.get(
    `/medico/agendaaberta?id=${id}&dt=${dt}&procedimentos=${procedimentos}`
  );
  return Array.isArray(response.data) ? response.data : [];
};

export { findMedicoByName, updateMedico, getAgendaAberta };
